var $discolorSlider = $($("#noUiSlider-discolour"));
if ($discolorSlider.length) {
  $discolorSlider.noUiSlider({
    range: {
        'min': 0,
        '25%': 0.125,
        '50%': 0.5,
        'max': 1
    },
    start: 0.125,
    orientation: 'vertical',
    direction: 'rtl',
  }).on('slide', function() {
    var slider_val = $(this).val();
    if( slider_val <= 0.125 ){
      $(".dark_base_hand").css("opacity", slider_val*2);
      $(".dark_base2_hand").css("opacity", 0);
    } else if( slider_val > 0.125 && slider_val <= 0.5 ){
      $(".dark_base_hand").css("opacity", slider_val*2);
      $(".dark_base2_hand").css("opacity", 0);
    }else {
      $(".dark_base_hand").css("opacity", 1);
      $(".dark_base2_hand").css("opacity", (slider_val-0.5)*2);
    }
  });
}
$(".dark_base_hand").css("opacity", 0.26);
$(".dark_base2_hand").css("opacity", 0);


$('#Product-Slider').children().last().prev().after(
  '<div class="product-images__slide product-images__slide--image product-slide--full carat_divv">' +
  '<div class="box-gray1" style="height:115px">' +
  '<div id="view_carat_size_position" style="width:50%;margin:0 auto;">' +
  `<div class="view-with--caratSize" id="collapse-preview-diamond">
    <p class="view-with__title title_slider_carat" id="image_text_var">
      <span class="carat-text">View with Carat Size: </span>3/4 Carat
    </p>
    <!--carat_slider_div-->
    <div class="diamond-shape-select" id="carat_slider_div" style="padding-bottom: 7px;">
      <div class="carat-weight-noUiSlider shape-carat-noUiSlider">
        <div class="min"><span>1/2 c</span><strong>ara</strong>t</div>
        <div class="noUiSlider" id="carat_slider"
             onchange="track_event('Product Detail Page','CYO Rings','Setting|Diamond|Carat|' + $('#image_text_var').data('carat'),true)" ></div>
        <div class="max"><span>2 c</span><strong>ara</strong>t</div>
      </div>
    </div>
  </div>` +
  '</div>' +
  '</div>' +
  '</div>'
)
// $('#Product-Slider').children().eq(1).after(
//   '<div class="product-images__slide product-images__slide--image product-slide--full carat_divv">' +
//   '<div class="box-gray1" style="height:115px">' +
//   '<div id="view_carat_size_position" style="width:50%;margin:0 auto;">' +
//   `<div class="view-with--caratSize" id="collapse-preview-diamond">
//     <p class="view-with__title title_slider_carat" id="image_text_var">
//       <span class="carat-text">View with Carat Size: </span>3/4 Carat
//     </p>
//     <!--carat_slider_div-->
//     <div class="diamond-shape-select" id="carat_slider_div" style="padding-bottom: 7px;">
//       <div class="carat-weight-noUiSlider shape-carat-noUiSlider">
//         <div class="min"><span>1/2 c</span><strong>ara</strong>t</div>
//         <div class="noUiSlider" id="carat_slider"
//              onchange="track_event('Product Detail Page','CYO Rings','Setting|Diamond|Carat|' + $('#image_text_var').data('carat'),true)" ></div>
//         <div class="max"><span>2 c</span><strong>ara</strong>t</div>
//       </div>
//     </div>
//   </div>` +
//   '</div>' +
//   '</div>' +
//   '</div>'
// )
$('#carat_slider_div').attr('style', function () {
  return $(this).attr('style') + "padding-bottom: 0px !important;"
});

if (typeof top_carat_image_set === 'undefined') {
    top_carat_image_set = {}
}
if (typeof hand_skin_tone_set === 'undefined') {
    hand_skin_tone_set = {}
}
if (typeof side1_carat_image_set === 'undefined') {
    side1_carat_image_set = {}
}
if (typeof side2_carat_image_set === 'undefined') {
    side2_carat_image_set = {}
}
var shape = select_shape;
if (!shape) {
    shape = $('#ir234-shop-diamond .ir309-shape-thumbnails.active').data('shape');
}
app = new SliderController(shape, top_carat_image_set, hand_skin_tone_set, side1_carat_image_set, side2_carat_image_set);
app.load();